import fields from '@src/entities/ActionPath/includes/fields.json';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import React from 'react';

const { remediationMethod: remediationMethodField } = fields;

/**
 * Field: RemediationMethod
 *
 * Select the type of remediation method for the action path.
 *
 * @param form
 * @param isActiveAndManual
 * @returns {Element}
 * @constructor
 */
export function RemediationMethod({
  form = {
    validate: () => {},
  },
  isActiveAndManual,
}) {
  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/fields/RemediationMethod/RemediationMethod.jsx">
      <SelectInput
        isDisabled={isActiveAndManual}
        {...remediationMethodField}
        onChange={() => {
          form?.validate(
            `remediation[remediationMethod]`,
            () => {},
            () => {}
          );
        }}
      />
    </ErrorHandler>
  );
}
